export const adminRoutesNames = {
    HOME: 'home'
};
